
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 50 50"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M36.6 31.8c-.5 0-1.1.1-1.6.4l-6.7-3.8h4.9c2 0 3.3-1.3 3.3-3.3V25c0-2-1.3-3.3-3.3-3.3h-4.5L35 18c.5.2 1 .3 1.6.3 2.1 0 3.8-1.7 3.8-3.8 0-2.1-1.7-3.8-3.7-3.8s-3.6 1.5-3.8 3.5l-7.4 4.3s-.1 0-.1.1L22 12.9c-.4-.6-1-.9-1.6-.9-.2 0-.5 0-.7.1l-1.7.7c-.9.4-1.4 1.4-1.1 2.3l2 6.4h-3.4L14 19.9c-.4-.4-.9-.6-1.4-.6-.4 0-.8.1-1.1.3l-1.1.7c-.7.5-1 1.5-.7 2.3l1 2.4-1 2.4c-.3.8-.1 1.8.7 2.3l1.1.8c.3.2.7.3 1.1.3.5 0 1.1-.2 1.4-.6l1.4-1.6h3.4l-2 6.4c-.3 1 .2 2 1.1 2.3l1.7.7c.2.1.5.1.7.1.6 0 1.3-.3 1.6-.9l3.4-5.5 7.5 4.3c.2 1.9 1.8 3.5 3.8 3.5 2.1 0 3.8-1.7 3.8-3.8 0-2.2-1.7-3.9-3.8-3.9zM26.3 19.7l8.2-4.7c-.1-.2-.1-.3-.1-.5 0-1.3 1.1-2.3 2.3-2.3s2.3 1.1 2.3 2.3c0 1.3-1.1 2.3-2.3 2.3-.7 0-1.2-.2-1.6-.6l-8 4.7-.4-.6-.4-.6zm-5.9 16.4l-1.7-.7 2.7-8.9-6.9.1-2 2.3-1.1-.8 1.2-3.1-1.2-3.1 1.1-.8 2 2.3 6.9.1-2.7-8.9 1.7-.7 6 9.6h6.8c.6 0 1.4.2 1.4 1.4v.1c0 1.2-.8 1.4-1.4 1.4h-6.8l-6 9.7zm16.2 1.8c-1.3 0-2.3-1.1-2.3-2.3 0-.2.1-.3.1-.5l-8.2-4.7.7-1.2 8.1 4.6c.4-.3 1-.6 1.6-.6 1.3 0 2.3 1.1 2.3 2.3.1 1.3-.9 2.4-2.3 2.4z"}})])
          )
        }
      }
    